<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-woman`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c8.837 0 16 7.163 16 16 0 8.159-6.107 14.892-14 15.876V36h5a1 1 0 011 1v2a1 1 0 01-1 1h-5v5a1 1 0 01-1 1h-2a1 1 0 01-1-1l-.001-5H17a1 1 0 01-1-1v-2a1 1 0 011-1h5v-2.124C14.107 32.892 8 26.16 8 18 8 9.163 15.163 2 24 2zm0 4c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12S30.627 6 24 6z"/></svg>
</template>
<script>

export default {
  name: 'IconWoman',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
